import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'

import { NestedTreeControl } from '@angular/cdk/tree'
import { MatTreeNestedDataSource } from '@angular/material/tree'
import { forkJoin, Subscription } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { OfflineService } from '../../../../shared/offline.service'
import { PassageLod } from '../../../delivery/shared/passage/passage'
import { CommandeSettingsArticles, CommandeSettingsCoeff, CommandeSettingsDeliveries } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings'
import { CommandeParamSettingsService } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings.service'
import { LingerieService } from '../../../settings/commande-param/commande-param-settings/shared/lingerie.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { Commande, CommandeDetails, LigneCommande } from '../../shared/commande'
import { CommandeService } from '../../shared/commande.service'
import { Inventaire, LigneInventaire, Lingerie } from '../../shared/inventaire'

interface InventaireNode {
  id: number
  commande: Commande
  lingerie: Lingerie
  statut: any
  date_modification: Date
  children?: InventaireNode[]
}

@Component({
  selector: 'app-inventaire-edit',
  templateUrl: './inventaire-edit.component.html',
  styleUrls: ['./inventaire-edit.component.scss']
})
export class InventaireEditComponent implements OnInit, OnDestroy {

  public dateList: Array<moment.Moment> = []
  public minDate
  public passageList: PassageLod[] = []
  public commande: Commande
  public commandeLigne: LigneCommande[] = []
  public commandeSettingsArticles: CommandeSettingsArticles[]
  public loading: boolean = false
  public isQuantitiesAt0: boolean = false
  public isSubmittable: boolean = false
  public curDay: string
  public curDayNumber: number = 1
  public coefficient: CommandeSettingsCoeff
  public commandeSettingsDeliveries: CommandeSettingsDeliveries[]
  public curDayMultiplier: CommandeSettingsDeliveries[] = []
  public isDaySelectable: boolean = false
  public commandsDaySelected: CommandeDetails[] = []
  public notificationServiceOpen: boolean = false
  public dateSelected: boolean = false
  public jourLingerieDotationList: Inventaire[] = []

  inventaireDetails: Inventaire
  inventaireId: string
  currentClient: Client
  statutInventaires: []
  dateLivraison: string

  treeControl = new NestedTreeControl<InventaireNode>(node => node.children)
  dataSource = new MatTreeNestedDataSource<Inventaire>()

  isOnline: boolean = true

  isBesoin: boolean = false

  subClient: Subscription

  constructor(
    private commandeSettingsService: CommandeParamSettingsService,
    private clientService: ClientService,
    private commandeService: CommandeService,
    private snackBar: MatSnackBar,
    private router: Router,
    private notificationService: NotificationService,
    private lingerieService: LingerieService,
    private route: ActivatedRoute,
    private offlineService: OfflineService
  ) {
    moment().locale('fr')
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  hasChild = () => true

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.inventaireId = params.id
      this.subClient = this.clientService.getCurrentClient().subscribe(client => {
        this.currentClient = client
        if (this.currentClient != null) {
          this.loading = true;

          forkJoin(
            {
              articles: this.commandeSettingsService.getCommandSettingsArticles(this.currentClient.id),
              coefficient: this.commandeSettingsService.getCommandMaxOrderRatio(client.id),
              deliveries: this.commandeSettingsService.getCommandDeliveries(this.currentClient.id),
              inventaires: this.commandeService.getInventaire(this.inventaireId)
            }
          ).subscribe({
            next: ({ articles, coefficient, deliveries, inventaires }) => {
              // Récupération des données du back
              this.commandeSettingsArticles = articles
              this.coefficient = coefficient
              this.commandeSettingsDeliveries = deliveries
              this.inventaireDetails = inventaires

              // Si l'inventaire est un besoin
              if (this.inventaireDetails.commande?.flag_besoin) {
                this.isBesoin = true;
              }

              // Récupération des dotations
              this.lingerieService.getDotations(inventaires.lingerie.id).subscribe((dotations) => {
                if (inventaires.commande) {
                  this.dateLivraison = inventaires.commande.date_livraison
                  if (dotations.length > 0) {
                    this.commandeSettingsArticles.forEach(article => {
                      let dotationValue = this.getDotation(article.article.id, dotations)
                      if (dotationValue != 0) {
                        let indexArticle = inventaires.inventaire_lignes.findIndex(ligne => ligne.article.id === article.article.id)
                        if (indexArticle == -1) {
                          let articleObj = { id: article.article.id, designation: article.article.designation }
                          inventaires.inventaire_lignes.push({ article: articleObj, dotation: dotationValue, restant: null, qte_commande: 0 })
                        } else {
                          inventaires.inventaire_lignes[indexArticle].dotation = dotationValue
                        }
                      }
                    })
                  }
                }
                this.loading = false
              })
            }
          })
        }
      })
    })
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getDotation(articleId, dotations): number {
    let coeff = this.currentClient.enabled_coeff ? this.coefficient?.coeff_max_commande : 1
    let dotations_jour
    if (this.currentClient.is_comptage_jour || this.isBesoin) {
      dotations_jour = dotations.filter(ligne => ligne.jour_livraison == new Date(this.dateLivraison).getDay())
    } else {
      dotations_jour = dotations.filter(ligne => ligne.jour_livraison == 0)
    }
    if (dotations_jour.length > 0) {
      let dotation = dotations_jour[0].dotations.filter(value => value.article.id == articleId)
      if (dotation.length > 0) {
        if (this.currentClient.is_comptage_jour || this.isBesoin) {
          return Math.ceil(+(dotation[0].quantite))
        } else {
          return Math.ceil(+(this.getDayMultiplier(this.dateLivraison) * dotation[0].quantite * coeff))
        }

      }
    }
    return 0
  }

  getDayMultiplier(date_livraison) {
    let curDayMultiplier = this.commandeSettingsDeliveries.filter(coef => coef.jrs_relivraison_lp === moment(date_livraison).day())
    if (!('multiple_mab_jour' in curDayMultiplier[0]) || curDayMultiplier[0].multiple_mab_jour === 0) {
      return 1
    } else {
      return curDayMultiplier[0].multiple_mab_jour
    }
  }

  getClientDeliveries(client) {
    this.commandeSettingsService.getCommandDeliveries(this.currentClient.id).subscribe(
      (data) => {
        this.commandeSettingsDeliveries = data
      }
    )
  }

  updateInventaire(ligne: LigneInventaire, event: any) {
    if (!ligne.dotation) {
      if (event.target.value > 0) {
        this.notificationService.notif("Quantité saisie supérieure à la dotation", 'warn')
      }
      event.target.value = 0
    }
    else if (+event.target.value > ligne.dotation) {
      event.target.value = ligne.dotation
      this.notificationService.notif("Quantité saisie supérieure à la dotation", 'warn')
    }
    else if (+event.target.value < 0) {
      event.target.value = 0
    }
    ligne.restant = event.target.value !== "" ? +event.target.value : null
    ligne.qte_commande = ligne.restant != null ? ligne.dotation - ligne.restant : 0
  }

  omit_not_number(e) {
    var k
    document.all ? k = e.keyCode : k = e.which
    return ((k > 96 && k < 106) || k == 8 || k == 32 || (k >= 48 && k <= 57))
  }

  saveInventaire(inventaire) {
    if (!this.isOnline) {
      this.notificationService.notif("L'inventaire de la lingerie " + inventaire.lingerie.libelle + " va être enregistré automatiquement quand vous serez en ligne", "warn", 6000)
    }

    this.offlineService
      .isOnlinePromise()
      .then(res => {
        if (res) {
          this.commandeService.postInventaire(inventaire).subscribe(data => {
            inventaire.statut = data.statut
            this.router.navigate(['/escli/linge-hebergement/list']).then(data => {
              this.notificationService.notif("L'inventaire de la lingerie " + inventaire.lingerie.libelle + " a été enregistré", "notif")
            })
          })
        }
      })
  }

  refuse() {
    this.router.navigate(['/escli/linge-hebergement/list'])
  }
}
